import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  HashRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { createBrowserHistory } from "history";
import ProtectedRoute from "hocs/ProtectedRoute/ProtectedRoute";

// core components
import AppsLayout from "./layouts/Admin";
import HomeLayout from "layouts/Home.js";
import OAuth2RedirectHandler from "views/pages/OAuth2RedirectHandler";
import ModuleSelection from "views/pages/ModuleSelection.js";
import LoginPage from "views/pages/LoginPage.js";
import AuthorizationStatus from "views/pages/AuthorizationStatus";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";

const hist = createBrowserHistory();
const updateFavicon = (newFavicon) => {
  console.log(newFavicon,"newFaviconnewFavicon")
  const favicon = document.getElementById('dynamic-favicon');
  if (favicon) {
    favicon.href = newFavicon;
  } else {
    const link = document.createElement('link');
    link.id = 'dynamic-favicon';
    link.rel = 'shortcut icon';
    link.href = newFavicon;
    document.head.appendChild(link);
  }
};
export default function App() {
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });

    updateFavicon(result?.data?.faviconUrl);
  };
  console.log("App");
  return (
    <BrowserRouter history={hist}>
      <Routes>
        <Route path="apps" element={<AppsLayout />}>
          <Route path="modules" element={<ModuleSelection />} />
        </Route>
        <Route path="home" element={<HomeLayout />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="complete" element={<AuthorizationStatus />} />
        </Route>
        <Route path="oauth2" element={<OAuth2RedirectHandler />} />
        <Route path="/auto/:autoId" element={<Navigate to="/apps/modules" />} />
        <Route path="*" element={<Navigate to="/home/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
